import apiCompetitiveActivity from '@/api/competitive-activity'

const state = {
  isSubmitting: false,
  validationErrors: null,
}

export const mutationTypes = {
  competitiveActivityCreateStart:
    '[competitive activity create] competitiveActivity create Start',
  competitiveActivityCreateSuccess:
    '[competitive activity create] competitiveActivity create Success',
  competitiveActivityCreateFailure:
    '[competitive activity create] competitiveActivity create Failure',
}

export const actionType = {
  competitiveActivityCreate:
    '[competitive activity create] competitiveActivity create',
}

const mutations = {
  [mutationTypes.competitiveActivityCreateStart](state) {
    state.isSubmitting = true
    state.validationErrors = null
  },

  [mutationTypes.competitiveActivityCreateSuccess](state) {
    state.isSubmitting = false
  },

  [mutationTypes.competitiveActivityCreateFailure](state, payload) {
    state.isSubmitting = false
    state.validationErrors = payload
  },
}

const actions = {
  [actionType.competitiveActivityCreate](context, directory) {
    context.commit(mutationTypes.competitiveActivityCreateStart)
    return new Promise((resolve) => {
      apiCompetitiveActivity
        .addCompetitiveActivity(directory)
        .then((response) => {
          context.commit(
            mutationTypes.competitiveActivityCreateSuccess,
            response.data
          )
          resolve(response.data)
        })
        .catch((result) => {
          context.commit(
            mutationTypes.competitiveActivityCreateFailure,
            result.response.data.errors
          )
        })
    })
  },
}

export default {
  state,
  mutations,
  actions,
}
